import { GET_PROJECTS } from "constants/projects";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PROJECTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
